<article class="ds-toast" [ngClass]="hostClasses">
    <header class="ds-toast__header">
        <mat-icon class="ds-toast__header-icon" fontSet="material-symbols-rounded" aria-hidden="true">{{ themeIcon }}</mat-icon>

        <h4 class="ds-toast__header-title">{{ header }}</h4>
    </header>

    <div class="ds-toast__content" [innerHTML]="content"></div>

    <ng-container *ngIf="hasClose">
        <ds-icon-button
            class="ds-toast__close"
            size="sm"
            theme="tertiary-gray"
            icon="close"
            (click)="closeClick.emit($event)"
        ></ds-icon-button>
    </ng-container>
</article>
